<template>
  <div class="container">
    <div class="bg"></div>
    <div class="top">
      <div class="logo"><router-link to='/Index'><img src="../assets/logo.png"></router-link></div>
    </div>
    <ul class="nav">
      <li ><router-link to='/Index'>企业介绍</router-link></li>
      <li class="current" style="position: relative" v-on:click="showmenu">添加溯源
        <ul class="ej" v-if="menu_show">
          <li class="current"><router-link to='/Product'>产品列表</router-link></li>
          <li><router-link to='/Add'>添加产品</router-link></li>
          <li><router-link to='/Model_list'>添加溯源</router-link></li>
        </ul>
      </li>
      <li style="position: relative" v-on:click="showmenu1">实时监控
        <ul class="ej" v-if="menu_show1">
          <li class="current"><router-link to='/Video'>直播</router-link></li>
          <li><router-link to='/Weather'>气象数据</router-link></li>
        </ul>
      </li>
    </ul>
    <div>
      <cube-input v-model="value"  style="margin: 10px 20px" placeholder="请输入产品批次名称"></cube-input>
      <p class="tip"><span style="color: red">建议:</span>输入需要溯源产品的批次名称建议前缀加时间缩写</p>
    </div>
    <p class="title_name"><span>选择模版</span><span>自定义模版请登陆PC端</span></p>
    <ul class="md_list">
      <li><router-link to='/Model_creat'>通用模版</router-link></li>
      <li><router-link to='/Model_creat'>通用完整</router-link></li>
      <li><router-link to='/Model_creat'>糯玉米</router-link></li>
      <li><router-link to='/Model_creat'>自定义玉米模版1</router-link></li>
    </ul>

    <div class="tab">
      <cube-tab-bar
        v-model="selectedLabelDefault"
        :data="tabs"
        @change="changeHandler">
      </cube-tab-bar>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Model_list",
    data(){
      return {
        menu_show:false,
        menu_show1:false,
        value:'',
        selectedLabelDefault: '首页',
        action: {
          target: '//jsonplaceholder.typicode.com/photos/',
          prop: 'base64Value'
        },
        indicator: {
          negative: true,
          remain: true
        },
        tabs: [{
          label: '首页',
          icon: 'cubeic-home'
        },
          {
            label: '我的',
            icon: 'cubeic-person'
          }],
        items: [
          {
            url: 'http://www.didichuxing.com/',
            image: 'http://www.zixunxueli.com/img/banner.jpg'
          }
        ],
        options: ['玉米', '土豆','西红柿', '火龙果','蔬菜'],
      }
    },
    methods:{
      changeHandler (label) {
        if(label=='我的'){
          this.$router.push({path:'Center'});
        }
        else{
          this.$router.push({path:'Index'});
        }
      },
      change(label){
        this.value=label;
      },
      filesAdded(files) {
        let hasIgnore = false
        const maxSize = 1 * 1024 * 1024 // 1M
        for (let k in files) {
          const file = files[k]
          if (file.size > maxSize) {
            file.ignore = true
            hasIgnore = true
          }
        }
        hasIgnore && this.$createToast({
          type: 'warn',
          time: 1000,
          txt: 'You selected >1M files'
        }).show()
      },
      showmenu(){
        if(this.menu_show==true){
          this.menu_show=false
        }
        else if(this.menu_show==false){
          this.menu_show=true
        }
      },
      showmenu1(){
        if(this.menu_show1==true){
          this.menu_show1=false
        }
        else if(this.menu_show1==false){
          this.menu_show1=true
        }
      }
    }
  };
</script>

<style scoped>
  *{
    padding: 0;
    margin: 0;
  }
  .bg{
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    background-color: #f5f5f5;
  }
  .top{
    height:3rem;
    background-color: #45b035;
  }
  .logo{
    width: 30%;
    line-height: 3rem;
  }
  .logo img{
    width: 100%;
    margin-top: 10px;

  }
  .tab{
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #f1ebeb;
    background-color: white;
  }
  /deep/ .tab {
    font-size: 14px;
  }
  /deep/ .tab i {
    font-size: 20px;
  }

  .nav{
    list-style: none;
    display: flex;
    justify-content: space-between;
    border-bottom:  1px solid #f1ebeb;
    background-color: white;
  }
  .nav a{
    color: #333333;
  }
  .nav li{
    width: 33%;
    padding: 10px 0;
  }
  .nav li:hover{
    color: #45b035;
  }
  .current{
    color: #45b035;
  }
  .banner img{
    width: 100%;
  }
  .introduce{
    text-align: left;
    font-size: 0.8rem;
    color: #999999;
    padding:0rem 1rem;
    background-color: white;
    margin: 0 0.5rem;
    padding:0.8rem;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    top: -20px;
  }
  .introduce p{
    margin-bottom: 0.5rem;
  }
  .store {
    background-color: white;
    padding: 0.8rem;
  }
  h3{
    font-size:0.9rem;
    text-align: left;
    position: relative;
    padding-left: 10px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }
  h3:before{
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 3px;
    height: 16px;
    background-color: #45b035;
  }
  .img_content{
    display: flex;
    margin: 10px 0;
    justify-content: space-around;
  }
  .store p{
    width: 30%;
  }
  .store p img{
    width: 100%;
  }
  .list{
    padding-bottom:60px;
    margin-top: 10px;
  }
  .left_img{
    width: 30%;
  }
  .left_img img{
    width: 100%;
  }
  .list_content{
    display: flex;
    padding: 5px;
    margin-top: 10px;
    box-shadow: 0px 0px 3px #ece6e6;
  }
  .title{
    width: 70%;
    text-align: left;
  }
  h4{
    font-size:1rem;
    margin-top: 1.3rem;
    color: #2c3e50;
    margin-left: 1rem;
  }
  .sub{
    font-size: 0.8rem;
    margin-top: 1.3rem;
    color:red;
    margin-left: 1rem;
  }
  .more{
    float: right;
    color: #b8b8b8;
    font-size: 0.8rem;
  }
  .look{
    float: right;
    color: #45b035;
  }
  .it{
    font-size: 0.6rem;
    margin: 5px 0;
    margin-left: 1rem;
  }
  .add_cot{
    padding: 10px;
    display: flex;
  }
  .name{
    font-size: 0.8rem;
    width:20%;
    text-align: right;
    padding: 10px 0;
    padding-right: 5px;
  }
  .tip{
    padding: 0 20px;
    color: #999999;
    font-size: 0.6rem;
  }
  .title_name{
    width: 90%;
    margin: 20px auto 10px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e6e6;
    padding-bottom: 10px;
  }
  .title_name span{
    display: block;
    color: #45b035;
    font-weight: bold;
    font-size: 0.9rem;
  }
  .md_list li{
    width: 90%;
    padding: 10px 0;
    text-align: left;
    margin: 0 auto;
    border-bottom: 1px solid #e8e6e6;
    font-size: 0.8rem;
  }
  .ej{
    position: absolute;
    width: 100%;
    background-color: #45b035;
    left: 0;
    top: 38px;
    z-index: 100;
    text-align: right;
  }
  .ej li{
    width: 100%;
    text-align: center;
    color: white;
    border-bottom: 1px solid #fff;
  }

  .ej li a{
    width: 100%;
    text-align: center;
    color: white;

  }
  .ej li a:hover{
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Model_list.vue